<!-- Password Change form -->
<ng-container *ngIf = "loading">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</ng-container>
<ng-container *ngIf="!loading">
<div class="page-wrapper bg-gra-01 p-t-45 p-b-50">
    <div class="wrapper wrapper--w790">
        <div class="card card-5">
            <!-- Error message -->
            <div class="alert" *ngIf="serverErrorMessages">
              {{serverErrorMessages}}
          </div>
            <div class="card-heading">
                <h2 class="title">Welcome {{userDetails.fullName}}</h2>
                <br>
                <h2 class="title">Change Password</h2>
            </div>
                    <form [formGroup]="passwordChangeForm" (ngSubmit)="onSubmit()">
                        <div class="card-body">
                            <!-- form start-->
                            <div class="form-row">
                              <div *ngIf="!otpSent" class="col-10">
                                  <div class="value">

                                        <div class="name">OLD PASSWORD</div>
                                          <div class="input-group">
                                              <input class="input--style-5"
                                              type="password" formControlName = "oldPassword" style="border-radius: 15px;"
                                              appBlockCopyPaste>

                                              <mat-error *ngIf="passwordChangeForm.controls['oldPassword'].invalid && passwordChangeForm.controls['oldPassword'].errors.required">Old Password is required</mat-error>
                                          </div>
                                    </div>
                              </div>
                              <!-- old pass done-->
                              <div *ngIf="otpSent">
                                <div class="col-10">
                                  <div class="value">
                                      <div class="name">ENTER OTP</div>
                                      <div class="input-group">
                                          <input class="input--style-5"
                                                type="password" formControlName="otp" style="border-radius: 15px;"
                                                appBlockCopyPaste>

                                          <mat-error *ngIf="passwordChangeForm.controls['otp'].invalid && passwordChangeForm.controls['otp'].errors.required">OTP is required</mat-error>

                                      </div>
                                  </div>
                              </div>
                               <div class="col-10">
                                      <div class="value">
                                          <div class="name">NEW PASSWORD</div>
                                          <div class="input-group">
                                              <input class="input--style-5"
                                                    type="password" formControlName="newPassword" style="border-radius: 15px;"
                                                    appBlockCopyPaste>

                                              <mat-error *ngIf="passwordChangeForm.controls['newPassword'].invalid && passwordChangeForm.controls['newPassword'].errors.required">New Password is required</mat-error>

                                              <mat-error *ngIf="passwordChangeForm.get('oldPassword').value === passwordChangeForm.get('newPassword').value"><br>New and Old passwords can't be same</mat-error>
                                          </div>
                                      </div>
                                  </div>
                                <!-- password done -->
                                <div class="col-10" >
                                  <div class="value">
                                      <div class="name">CONFIRM PASSWORD</div>
                                      <div class="input-group">
                                          <input class="input--style-5"
                                                type="password" formControlName="confirmPassword" style="border-radius: 15px;"
                                                appBlockCopyPaste>

                                          <mat-error *ngIf="passwordChangeForm.controls['confirmPassword'].invalid && passwordChangeForm.controls['confirmPassword'].errors.required">Confirm Password is required</mat-error>

                                          <mat-error *ngIf="passwordChangeForm.get('newPassword').value !== passwordChangeForm.get('confirmPassword').value">Passwords must match</mat-error>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>

                            <!-- form end-->

                            <div>
                                <button *ngIf="!otpSent" type="submit" class="btn btn-primary" style="padding: 15px;" (click)="sendOTP()">Generate OTP</button>
                                <button *ngIf="otpSent" type="submit" class="btn btn-primary" style="padding: 15px;">Submit</button>
                                <br>
                                <div *ngIf="otpSent"><h5>OTP sent to {{hideEmail(userDetails.email)}}</h5></div>
                                <br>
                                <a href="/home"><button type="button" class="btn btn-primary" style="padding: 15px;">Cancel</button></a>

                                <br/>
                            </div>
                        </div>
                    </form>

        </div>
    </div>
</div>
</ng-container>

